import * as React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import 'moment/locale/pt-br';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { unregister } from './registerServiceWorker';
import routes from './routes/routes';

import '@quality24/design-system/src/styles/global.scss';
import './instrumentation';

moment.locale('pt-BR');

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in index.html');
}

const root = createRoot(container);

root.render(<RouterProvider router={createBrowserRouter(routes)} />);

unregister();
